<div class="names-az" role="list" aria-label="Browse names A to Z">
  <a class="az-pill az-pill--all"
     role="listitem"
     tabindex="0"
     [class.is-active]="activeLetter === null"
     (click)="onAllClick()"
     (keydown.enter)="onAllClick()">
    <strong>All</strong>
  </a>
  <a *ngFor="let pill of pills"
     class="az-pill"
     role="listitem"
     tabindex="0"
     [class.is-empty]="pill.empty"
     [class.is-active]="pill.letter === activeLetter"
     [attr.aria-disabled]="pill.empty ? 'true' : null"
     [attr.aria-pressed]="pill.letter === activeLetter"
     (click)="onClick(pill)"
     (keydown.enter)="onClick(pill)">
    <strong>{{ pill.letter }}</strong>
    <span class="az-count">{{ pill.count }}</span>
  </a>
</div>
